import { setFormElementValueByName } from '@form-engine/core-application/hooks/use-formsession';
import {
    WorkflowLayerArgs,
    WorkflowLayerResponse,
    WorkflowLayerType,
} from '@form-engine/core-application/types/form';
import { getFormSessionLocals } from '@form-engine/core-application/utilities/form-session';
import { compileObject } from '@form-engine/core-util/create-object';
import { compile } from '@form-engine/core-util/template';

async function FormEngineSetterWfl({
    session,
    definition,
    form,
}: WorkflowLayerArgs): Promise<WorkflowLayerResponse> {
    if (definition.type !== apiName) {
        throw new Error('invalid workflow definition');
    }
    const sessionUpdate = { ...session };
    if (definition.assignments) {
        const locals = getFormSessionLocals(form, sessionUpdate);
        const map = compileObject(definition.assignments, locals);
        Object.entries(map).forEach(([key, value]) => {
            key = compile(key, locals);
            if (key.startsWith('values.')) {
                setFormElementValueByName(
                    form,
                    sessionUpdate,
                    key.slice(7),
                    value
                );
            } else {
                sessionUpdate.locals ??= {};
                sessionUpdate.locals[key] = value;
            }
        });
    }

    return Promise.resolve(sessionUpdate);
}

export const apiName = (FormEngineSetterWfl.apiName = 'FormEngineSetterWfl');

export default FormEngineSetterWfl as WorkflowLayerType;
